import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Korean%20webtoon%20artistic%20illustration%20collage%20with%20various%20comic%20characters%20in%20dramatic%20poses%2C%20warm%20golden%20and%20crimson%20tones%2C%20dynamic%20composition%2C%20stylized%20manhwa%20aesthetic%2C%20abstract%20ink%20wash%20background%2C%20professional%20digital%20art%20with%20rich%20textures&width=1920&height=1080&seq=hero-banner-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide leading-tight">
          韩漫免费阅读
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          无遮韩国漫画大全 —— 内容多样、操作简单，为您打造最佳的韩漫在线阅读体验
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/category/fantasy"
            className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap hover:scale-105"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-8 mt-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">2000+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">漫画作品</p>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">50万+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">每日读者</p>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">8个</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">类型分类</p>
          </div>
        </div>
      </div>
    </section>
  );
}